import React, { useState, useEffect, useRef } from "react";
import useUserStore from "../../utils/storeApp";
import CallAPI from "../../services/apiCalls";
import $ from "jquery";

let ob = {
  OrgId: null,
  EmailPurpose: false,
  OrgName: null,
  PurposeId: 0,
  NewDirectEmail: "",
  DomainName: null,
  Flag: false,
  NoReplay: false,
  DirectTrustServiceDescriptionCode: "any-all",
};
const AddOrgEmail = () => {
  const { userToken, sharedObject, SetSharedObject } = useUserStore(
    (state) => ({
      userToken: state.userToken,
      sharedObject: state.sharedObject,
      SetSharedObject: state.SetSharedObject,
    })
  );
  const [answers, setAnswers] = useState(ob);
  const [processing, SetProcessing] = useState(false);
  const [frmSubmFlag, SetFrmSubmFlag] = useState(false);
  const [errMsg, SetErrMsg] = useState(false);
  const [returnMsg, SetReturnMsg] = useState(false);
  const [msg, SetMsg] = useState("");
  const [errEmail, SetErrEmail] = useState(false);
  const modalTriggerRef = useRef(null);
  const setAnswer = (key, value) => {
    setAnswers((prev) => ({ ...prev, [key]: value }));
  };
  useEffect(() => {
    const setEmails = async (obj) => {
      let o = {
        OrgId: obj?.id ? obj?.id : null,
        EmailPurpose: false,
        OrgName: obj?.name ? obj?.name : null,
        PurposeId: 0,
        NewDirectEmail: "",
        DomainName: obj?.domainName ? obj?.domainName : null,
        Flag: obj?.Flag ? obj?.Flag : false,
        NoReplay: obj?.NoReplay ? obj?.NoReplay : false,
        DirectTrustServiceDescriptionCode: "any-all",
      };
      await setAnswers(o);
    };
    setEmails(sharedObject.orgActionObj);
    return () => {
      SetFrmSubmFlag(false);
      SetErrMsg(false);
      SetReturnMsg(false);
      setAnswers(ob);
    };
  }, [sharedObject.orgActionObj]);
  const addEmailOrg = async () => {
    SetErrEmail(false);
    SetFrmSubmFlag(true);
    SetErrMsg(false);
    SetReturnMsg(false);
    if (answers.NewDirectEmail === "") {
      document.getElementById("NewDirectEmail").scrollIntoView();
      document.getElementById("NewDirectEmail").focus();
      return;
    } else if (
      answers.NewDirectEmail !== "" &&
      (containsSpacesOrSpecialChars(answers.NewDirectEmail) ||
        answers.NewDirectEmail.length < 3)
    ) {
      document.getElementById("NewDirectEmail").scrollIntoView();
      document.getElementById("NewDirectEmail").focus();
      SetErrEmail(true);
      return;
    }
    SetProcessing(true);
    let call =
      "/emails/AddOrganizationDirectEmail?orgId=" +
      answers.OrgId +
      "&newDirectEmail=" +
      answers.NewDirectEmail +
      "&purposeId=" +
      answers.PurposeId +
      "&domainName=" +
      answers.DomainName +
      "&emailPurpose=" +
      answers.EmailPurpose +
      "&emailNoReplay=" +
      answers.NoReplay +
      "&directTrustServiceDescriptionCode=" +
      answers.DirectTrustServiceDescriptionCode;
    const res = await CallAPI(call, null, "get", userToken, false);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetMsg("Direct email has been added successfully.");
      SetProcessing(false);
      SetReturnMsg(true);
      if (answers.Flag) SetSharedObject("reloadEmailList", true);
      resetForm(true);
      setTimeout(() => document.getElementById("NewDirectEmail")?.focus(), 0);
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      if (Object.keys(msg).length > 0 && msg.constructor === Object) {
        let str = "<div>";
        for (let el in msg) {
          str += `${el}`;
        }
        str += "</div>";
        SetMsg(str);
      } else {
        if (msg.includes("Cannot insert duplicate key")) {
          SetMsg(
            "Email already exists. Please try again with a different name."
          );
        } else {
          SetMsg(
            "System encoountered an error. Please try again. If the problem persists, please contact your administrator."
          );
        }
      }
      SetErrMsg(true);
      SetReturnMsg(true);
      SetProcessing(false);
    }
  };
  const containsSpacesOrSpecialChars = (str) => {
    let flag = /[^a-zA-Z0-9-_@.]/.test(str);
    return flag;
  };

  const resetForm = (keepContext = true) => {
    setAnswers((prev) => ({
      OrgId: keepContext ? prev.OrgId : null,
      OrgName: keepContext ? prev.OrgName : null,
      DomainName: keepContext ? prev.DomainName : null,
      Flag: keepContext ? !!prev.Flag : false,
      NoReplay: false,
      // cleared/field defaults:
      NewDirectEmail: "",
      PurposeId: 0,
      EmailPurpose: false,
      DirectTrustServiceDescriptionCode: "any-all",
    }));

    SetFrmSubmFlag(false);
    SetErrMsg(false);
    SetErrEmail(false);
    };

    const CloseModal = () => {
    if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
    }

    $('#AddOrgEmailModal').modal('hide');
    modalTriggerRef.current?.focus();
    };

    // Add Escape key handler for modals
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        // Close any open modal
        if ($("#AddOrgEmailModal").hasClass("show")) CloseModal();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  useEffect(() => {
    const $modal = $("#AddOrgEmailModal");

    const onShown = () => {
      // Clear messages but keep org context when opening
      resetForm(true);
    };
    const onHidden = () => {
      // Full reset if you want when closing
      resetForm(false);
    };

    $modal.on("shown.bs.modal", onShown);
    $modal.on("hidden.bs.modal", onHidden);

    return () => {
      $modal.off("shown.bs.modal", onShown);
      $modal.off("hidden.bs.modal", onHidden);
    };
  }, []);

  return (
    <div className="AddOrgEmail">
      <div
        className="modal fade"
        id="AddOrgEmailModal"
        data-backdrop="static"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="AddOrgEmailModalTitle"
        aria-describedby="AddOrgEmailModalDesc"
        aria-modal="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title" id="AddOrgEmailModalTitle">
                Add Organization Email
              </h3>
              <button
                type="button"
                className="close"
                aria-label="Close add organization email"
                onClick={CloseModal}
                 disabled={processing}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
                <p id="AddOrgEmailModalDesc" className="sr-only">
                    Use this form to add a new direct email address for the organization.
              </p>
              <div className="modal-content-form">
                <form className="needs-validation" noValidate aria-label="Add organization email form">
                  <div className="field-wrapper">
                    <label>Organization:</label>
                    <span className="txt-s11">{answers?.OrgName}</span>
                  </div>
                  <div className="field-wrapper">
                    <label htmlFor="NewDirectEmail">Email Name<span aria-hidden="true" className="rd-clr"> *</span></label>
                    <div className="input-group mb-3">
                      <input
                        type="text"
                        className="form-control field-direct"
                        autoComplete="off"
                        placeholder="Enter new email name"
                        maxLength={`${257 - answers?.DomainName?.length}`}
                        id="NewDirectEmail"
                        aria-required="true"
                        aria-describedby="emailDomainSuffix emailNameHint"
                        value={answers?.NewDirectEmail}
                        onChange={(el) => {
                          SetReturnMsg(false);
                          SetErrMsg(false);
                          setAnswer("NewDirectEmail", el.target.value);
                        }}
                      />
                      <div className="input-group-append">
                        <span
                          className="input-group-text field-direct-addon"
                          id="emailDomainSuffix"
                        >
                          @{answers?.DomainName}
                        </span>
                      </div>
                    </div>
                    <span id="emailNameHint" className="sr-only">
                      Enter only the local part of the email. The domain will be appended automatically.
                      Minimum 3 characters. No spaces or special characters allowed.
                    </span>
                    {answers?.NewDirectEmail === "" && frmSubmFlag ? (
                      <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                        Email Name field is required.
                      </div>
                    ) : null}
                    {errEmail ? (
                      <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                        Please enter a valid email name with more than 3
                        characters long, no spaces, commas, or special
                        characters.
                      </div>
                    ) : null}
                  </div>
                  <div className="field-wrapper w-set1">
                    <label htmlFor="PurposeId">What is the purpose?</label>
                    <div className="email-purpose-wrapper">
                      <select
                        className="form-control"
                        name="PurposeId"
                        id={"PurposeId"}
                        value={Number(answers?.PurposeId) ?? 0}
                        onChange={(e) =>
                          setAnswer("PurposeId", Number(e.target.value))
                        }
                      >
                        <option value={0}>General</option>
                        <option value={1}>Medical Records XML only</option>
                        <option value={2}>Medical Records</option>
                        <option value={3}>Administrative</option>
                      </select>
                    </div>
                    {answers?.PurposeId === "" && frmSubmFlag ? (
                      <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                        Purpose field is required.
                      </div>
                    ) : null}
                  </div>

                  <div className="field-wrapper w-set2">
                    <label htmlFor="EmailPurpose">Sharing Allowed?</label>
                    <button                      
                      type="button"
                      className="btn btn-link p-0 ml-1"
                      href="#OrgShareInfo"
                      aria-expanded="false"
                      aria-controls="OrgShareInfo"
                      aria-label="More information about sharing"
                      onClick={(e) => {
                        const expanded =
                          e.currentTarget.getAttribute("aria-expanded") === "true";
                        e.currentTarget.setAttribute(
                          "aria-expanded",
                          String(!expanded)
                        );
                        $("#OrgShareInfo").collapse("toggle");
                      }}
                    >
                      <i className="bi bi-plus-lg sm-icon-container" aria-hidden="true"></i>
                    </button>
                    <div className="collapse notes-msg-sm" id="OrgShareInfo">
                      If sharing is not allowed, then only one member can be
                      assigned to this email.
                    </div>
                    <div className="email-purpose-wrapper">
                      <select
                        className="form-control"
                        name="EmailPurpose"
                        id="EmailPurpose"
                        value={String(answers?.EmailPurpose)}
                        onChange={(e) =>
                          setAnswer("EmailPurpose", e.target.value === "true")
                        }
                      >
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>
                    </div>
                    {answers?.EmailPurpose === "" && frmSubmFlag ? (
                      <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                        Email Sharing Allowed field is required.
                      </div>
                    ) : null}
                  </div>

                  <div className="field-wrapper w-set1 select-wrapper">
                    <label htmlFor="ServiceDescription">
                      Service Description
                    </label>
                    <select
                      className="form-control"
                      id="ServiceDescription"
                      value={answers.DirectTrustServiceDescriptionCode}
                      onChange={(el) => {
                        setAnswer(
                          "DirectTrustServiceDescriptionCode",
                          el.target.value
                        );
                      }}
                    >
                      <option value="">Select</option>
                      {sharedObject?.getServDesc?.map((el) => (
                        <option key={el.code} value={el.code}>
                          {el.display}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/*<div className="field-wrapper">*/}
                  {/*  <div className="NoReply spacer-inline">*/}
                  {/*    <input*/}
                  {/*      className="form-control spacer-margin5 sp-mx"*/}
                  {/*      type="checkbox"*/}
                  {/*      id="NoReplay"*/}
                  {/*      value={answers?.NoReplay}*/}
                  {/*      onChange={(el) => {*/}
                  {/*        setAnswer("NoReplay", el.target.checked);*/}
                  {/*      }}*/}
                  {/*    />*/}
                  {/*  </div>*/}
                  {/*  <label className="v-top">Set as no-reply mailbox</label>*/}
                  {/*  <aside className="sp-margin13 line-s1">*/}
                  {/*    Check this box if this mailbox cannot reply to emails.*/}
                  {/*  </aside>*/}
                  {/*</div>*/}

                  {returnMsg ? (
                    <div className="AlertMessages">
                      <div
                        className={`alert alert-${
                          errMsg ? "danger" : "success"
                        }`}
                        role="alert"
                        aria-live="assertive"
                        aria-atomic="true"
                      >
                        {msg}
                      </div>
                    </div>
                  ) : null}
                </form>
              </div>
            </div>
            <div className="modal-footer">
              {/*{processing ? (*/}
              {/*  <div className="loading"></div>*/}
              {/*) : <div className="spacer-inline">*/}
              {/*  <div className="reverse-spinner spinner1"></div>*/}
              {/*  <div className="spacer-inline spacer-margin2 dg-clr">*/}
              {/*    Processing...*/}
              {/*  </div>*/}
              {/*</div>*/}
              {/*null}*/}

              <button
                type="button"
                className="btn btn-success"
                onClick={(e) => addEmailOrg()}
                disabled={processing}
                aria-busy={processing}
              >
                {processing ? "Adding..." : "Add Email"}
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                 onClick={CloseModal}
                  disabled={processing}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddOrgEmail;
